// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu {
  --width: 100%;
}

.segment {
  --padding-end: 2px;
  --padding-start: 2px;
}

.theme-cover {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  color: var(--ion-text-color);
  align-items: center;
}

.staff-avatar {
  vertical-align: middle;
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

ion-menu ion-list ion-item {
  font-weight: 600;
  font-size: 1rem;
  color: #2d3244;
  --detail-icon-color: #000000;
  --detail-icon-opacity: 1;
  --detail-icon-font-size: 1.5rem;
  height: 40px;
  --inner-padding-bottom: 8px;
}

.close-button {
  font-size: 30px;
  color: var(--ion-text-color);
  position: relative;
  margin: 10px;
  align-self: end;
}

ion-select.lang-picker::part(icon) {
  display: none;
}

ion-select.lang-picker {
  font-weight: 500;
  font-size: 1rem;
  color: #181a23;
}

.item-inner {
  min-height: 1px !important;
}

.label-md {
  margin-bottom: 1px !important;
  margin-top: 1px !important;
}

ion-item-divider {
  margin-top: 0px;
  min-height: 1px !important;
}

ion-item {
  cursor: pointer;
}
ion-item:hover {
  --background: #f5f5f5;
}`, "",{"version":3,"sources":["webpack://./src/app/components/sidebar/sidebar.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,oBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,aAAA;EACA,4BAAA;EACA,mBAAA;AACF;;AAEA;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAII;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,4BAAA;EACA,wBAAA;EACA,+BAAA;EACA,YAAA;EACA,2BAAA;AADN;;AAMA;EACE,eAAA;EACA,4BAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAHF;;AAMA;EACE,aAAA;AAHF;;AAMA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAHF;;AAMA;EACE,0BAAA;AAHF;;AAMA;EACE,6BAAA;EACA,0BAAA;AAHF;;AAMA;EACE,eAAA;EACA,0BAAA;AAHF;;AAMA;EAEE,eAAA;AAJF;AAKE;EACE,qBAAA;AAHJ","sourcesContent":[".menu {\n  --width: 100%;\n}\n\n.segment {\n  --padding-end: 2px;\n  --padding-start: 2px;\n}\n\n.theme-cover {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 20px;\n  color: var(--ion-text-color);\n  align-items: center;\n}\n\n.staff-avatar {\n  vertical-align: middle;\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n}\n\nion-menu {\n  ion-list {\n    ion-item {\n      font-weight: 600;\n      font-size: 1rem;\n      color: #2d3244;\n      --detail-icon-color: #000000;\n      --detail-icon-opacity: 1;\n      --detail-icon-font-size: 1.5rem;\n      height: 40px;\n      --inner-padding-bottom: 8px;\n    }\n  }\n}\n\n.close-button {\n  font-size: 30px;\n  color: var(--ion-text-color);\n  position: relative;\n  margin: 10px;\n  align-self: end;\n}\n\nion-select.lang-picker::part(icon) {\n  display: none;\n}\n\nion-select.lang-picker {\n  font-weight: 500;\n  font-size: 1rem;\n  color: #181a23;\n}\n\n.item-inner {\n  min-height: 1px !important;\n}\n\n.label-md {\n  margin-bottom: 1px !important;\n  margin-top: 1px !important;\n}\n\nion-item-divider {\n  margin-top: 0px;\n  min-height: 1px !important;\n}\n\nion-item{\n\n  cursor: pointer;\n  &:hover{\n    --background: #f5f5f5;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
